// Archivo: src/pages/QuienesSomosPage.js
import React from "react";

// --- Iconos SVG para reutilización ---
const CodeIcon = () => (
  <svg
    className="w-8 h-8 text-white"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4"
    />
  </svg>
);

const NetworkIcon = () => (
  <svg
    className="w-8 h-8 text-white"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M8.684 13.342C8.886 12.938 9 12.482 9 12s-.114-.938-.316-1.342m4.632 2.684c.202.404.316.86.316 1.342s-.114.938-.316 1.342m0-2.684a3 3 0 11-2.632 0m2.632 0a3 3 0 10-2.632 0M9 6a3 3 0 110-6 3 3 0 010 6zm0 12a3 3 0 110-6 3 3 0 010 6zm12-6a3 3 0 11-6 0 3 3 0 016 0z"
    />
  </svg>
);

const SupportIcon = () => (
  <svg
    className="w-8 h-8 text-white"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192l-3.536 3.536M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
    />
  </svg>
);

const CheckIcon = () => (
  <svg
    className="w-7 h-7 text-gob-rojo"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={3}
      d="M5 13l4 4L19 7"
    />
  </svg>
);

// --- Componente de Sección Reutilizable (Estilo unificado) ---
const Section = ({ title, children }) => (
  <section className="mb-20">
    <h2 className="text-3xl font-bold text-gray-800 text-center mb-12 relative pb-3 after:content-[''] after:absolute after:left-1/2 after:-translate-x-1/2 after:bottom-0 after:w-24 after:h-1 after:bg-gob-rojo after:rounded-full">
      {title}
    </h2>
    <div className="space-y-8">{children}</div>
  </section>
);

// --- Componente de Tarjeta de Información ---
const InfoCard = ({ icon, title, children }) => (
  <div className="bg-white p-8 rounded-2xl border border-gray-200 shadow-sm hover:shadow-xl hover:border-gob-azul-medio transform hover:-translate-y-1 transition-all duration-300 flex flex-col h-full">
    <div className="flex items-start mb-5">
      <div className="flex-shrink-0 p-4 bg-gob-azul-oscuro rounded-full mr-5">
        {icon}
      </div>
      <h3 className="text-2xl font-bold text-gob-azul-oscuro">{title}</h3>
    </div>
    <div className="text-gray-600 text-lg leading-relaxed flex-grow">
      {children}
    </div>
  </div>
);

// --- Componente para Items de Lista con Icono ---
const FunctionListItem = ({ children }) => (
  <li className="flex items-start p-4 bg-gray-50/50 rounded-lg">
    <div className="flex-shrink-0 mt-1 mr-4">
      <CheckIcon />
    </div>
    <p className="text-gray-700 text-lg leading-relaxed">{children}</p>
  </li>
);

// --- Componente Principal de la Página ---
const QuienesSomosPage = () => {
  const organigramaImg = "/2.png";

  return (
    <div className="max-w-6xl mx-auto animate-fade-in-up px-4 sm:px-6 lg:px-8">
      {/* Encabezado Principal */}
      <header className="text-center py-12 mb-16 border-b border-gray-200">
        <h1 className="text-4xl md:text-5xl font-extrabold text-gob-azul-oscuro tracking-tight">
          Guía de Uso de los Sistemas
        </h1>
        <p className="text-lg md:text-xl text-gray-500 mt-4 max-w-3xl mx-auto">
          En este sitio encontrarás toda la documentación referente a los
          sistemas transversales a la Administración Pública
        </p>
      </header>

      {/* Contenido Principal */}
      {/* <main>
        <Section title="Nuestra Misión">
          <div className="text-center bg-gray-50 border-l-4 border-gob-azul-medio p-8 rounded-xl">
            <p className="text-xl md:text-2xl text-gray-700 italic leading-relaxed max-w-4xl mx-auto">
              "Mejorar la gestión de las entidades del Gobierno mediante la
              estandarización, regulación, control, integración y ejecución de
              los proyectos informáticos y de telecomunicaciones, otorgando
              productos y servicios de calidad."
            </p>
          </div>
        </Section>

        <Section title="Nuestra Estructura">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <InfoCard icon={<CodeIcon />} title="Dirección de Tecnologías">
              <p>
                Encargada de la gestión y desarrollo de las soluciones de
                software y sistemas de información.
              </p>
            </InfoCard>
            <InfoCard
              icon={<NetworkIcon />}
              title="Dirección de Comunicaciones"
            >
              <p>
                Responsable de la infraestructura de redes, conectividad y
                telecomunicaciones del gobierno.
              </p>
            </InfoCard>
            <InfoCard
              icon={<SupportIcon />}
              title="Dirección de Soporte T.I.C."
            >
              <p>
                Provee asistencia técnica, mantenimiento y soporte a todas las
                áreas gubernamentales.
              </p>
            </InfoCard>
          </div>
        </Section>

        <Section title="Funciones Generales">
          <ul className="space-y-4">
            <FunctionListItem>
              Articular y coordinar todo proyecto de supervisión de estándares,
              adquisición e implementación de tecnología.
            </FunctionListItem>
            <FunctionListItem>
              Analizar y observar la conveniencia del producto respecto a la
              oferta de mercado y las interfaces con otros sistemas del Estado.
            </FunctionListItem>
            <FunctionListItem>
              Solicitar bases de datos y demás información de todos los
              organismos de la Administración Pública Provincial.
            </FunctionListItem>
            <FunctionListItem>
              Suscribir convenios de intercambio de información con organismos
              provinciales, nacionales o internacionales.
            </FunctionListItem>
          </ul>
        </Section>

        <Section title="Organigrama">
          <div className="w-full p-6 border border-gray-200 rounded-2xl bg-white shadow-sm overflow-hidden">
            <img
              src={organigramaImg}
              alt="Organigrama de la Subsecretaría"
              className="max-w-full h-auto rounded-lg mx-auto"
            />
          </div>
        </Section>
      </main> */}
    </div>
  );
};

export default QuienesSomosPage;
